export default __webpack_public_path__ + "static/media/room2-MASK-ImageWall.5834cf99.png";